@import 'apps/webcomponents/src/assets/scss/mixins';

:host {
  --max-height-textarea: 64px;
  --text-area-white-space: pre-line;
}

.input {
  &.textarea-input-wrapper {
    height: 100%;
    min-height: var(--input-height);
    align-items: flex-start;

    &.floating-label .input--label,
    &:focus-within .input--label {
      @include floating-label(-70%);
      top: 1px;
      margin-top: 0;
    }

    .input--label {
      margin-top: var(--input-padding-top);
    }
  }

  &--textarea {
    white-space: var(--text-area-white-space);
    min-height: var(--input-height);
    height: 100%;
    outline: none !important;
    padding: var(--textarea-padding);

    &:focus {
      border-color: var(--blue-layout-500-focus);
      &::placeholder {
        color: var(--chart-300-icon-buttons);
      }
    }

    &:active {
      border-color: var(--blue-layout-300-active);
    }
  }
}

.tooltip {
  margin: calc(var(--spacer) / 2) calc(var(--spacer) / 2) 0 0;
}

:host([hasCounter]) {
  .input {
    &--textarea {
      max-height: var(--max-height-textarea);
      resize: var(--custom-resize, none);
      overflow-y: var(--custom-overflow, scroll);
    }
  }
}

:host([resizablebycontent]) {
  .input {
    &--textarea {
      padding: var(--textaria-padding, (calc(var(--spacer) / 2) 0 calc(var(--spacer) / 2) var(--spacer)));
      overflow: auto;
      resize: none;

      &::-webkit-scrollbar {
        width: 0 !important;
      }

      &:focus {
        &::placeholder {
          visibility: hidden;
        }
      }
    }
  }
}

:host([data-invalid]) {
  .input {
    &--textarea {
      padding-right: calc(var(--spacer) * 3 + 2px);
    }
  }

  gz-tooltip[tooltipclass='error'],
  gz-tooltip[tooltipclass='neutral'] {
    position: absolute;
    left: auto;
    right: calc(var(--spacer) + 2px);
  }
}

$maxRows: 10;
@for $row from 1 through $maxRows {
  :host([maxRows='#{$row}']) {
    .input {
      &--textarea {
        max-height: calc((var(--spacer) * 2 * (#{$row} + 1) - #{$row}px));
      }
    }
  }
}
